import { render, staticRenderFns } from "./DomainTypeLookup.vue?vue&type=template&id=19dac744&lang=pug"
import script from "./DomainTypeLookup.vue?vue&type=script&lang=js"
export * from "./DomainTypeLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports